export const feistyPets = [
  // PRINCESS POTTYMOUTH - GATA LARANJA
  {
    id: 1,
    name: "Princess Pottymouth",
    species: "Gata Laranja",
    wave: "Normal",
    rarity: "Comum",
    year: 2017,
    size: "Normal",
    description: "É um gato! Eles são fofos, mas são bravos! Os bichinhos de pelúcia Feisty Pets vão te atacar se você apertá-los. Os valentões da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://static.readdy.ai/image/1994e90a97157f2e2b62c14dfd6ce361/59460cadd1dff68c22b8a813f8848098.png",
    expressions: ["Presa"],
    variants: [1, 2, 3, 4, 5]
  },
  {
    id: 2,
    name: "Princess Pottymouth",
    species: "Gata Laranja",
    wave: "Chaveiro",
    rarity: "Comum",
    year: 2017,
    size: "Chaveiro",
    description: "É um gato! Eles são fofos, mas são bravos! Os bichinhos de pelúcia Feisty Pets vão te atacar se você apertá-los. Os valentões da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://static.readdy.ai/image/1994e90a97157f2e2b62c14dfd6ce361/95e16efffef8126b711d447c63a246ec.png",
    expressions: ["Presa"],
    variants: [1, 2, 3, 4, 5]
  },
  {
    id: 3,
    name: "Princess Pottymouth",
    species: "Gata Laranja",
    wave: "Normal",
    rarity: "Raro",
    year: 2017,
    size: "Normal",
    description: "É um gato! Eles são fofos, mas são bravos! Os bichinhos de pelúcia Feisty Pets vão te atacar se você apertá-los. Os valentões da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://static.readdy.ai/image/1994e90a97157f2e2b62c14dfd6ce361/b6d204b247e2f17d41b607e2f006dbc6.png",
    expressions: ["Sorriso"],
    variants: [1, 2, 3, 4, 5]
  },
  {
    id: 4,
    name: "Princess Pottymouth",
    species: "Gata Laranja",
    wave: "Normal",
    rarity: "Comum",
    year: 2017,
    size: "Normal",
    description: "É um gato! Eles são fofos, mas são bravos! Os bichinhos de pelúcia Feisty Pets vão te atacar se você apertá-los. Os valentões da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://static.readdy.ai/image/1994e90a97157f2e2b62c14dfd6ce361/e94041f2466e2536173100f5e76dbcd2.png",
    expressions: ["Doofus"],
    variants: [1, 2, 3, 4, 5]
  },
  {
    id: 5,
    name: "Princess Pottymouth",
    species: "Gata Laranja",
    wave: "Normal",
    rarity: "Épico",
    year: 2017,
    size: "Normal",
    description: "É um gato! Eles são fofos, mas são bravos! Os bichinhos de pelúcia Feisty Pets vão te atacar se você apertá-los. Os valentões da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://static.readdy.ai/image/1994e90a97157f2e2b62c14dfd6ce361/044a53c0b7295827f2f8ed8f0461af73.png",
    expressions: ["Língua"],
    variants: [1, 2, 3, 4, 5]
  },

  // SAMMY SUCKERPUNCH - LOBO
  {
    id: 6,
    name: "Sammy Suckerpunch",
    species: "Lobo",
    wave: "Normal",
    rarity: "Comum",
    year: 2017,
    size: "Normal",
    description: "É um cachorro! Eles são fofos, mas são bravos! Os bichinhos de pelúcia Feisty Pets vão te atacar se você apertá-los. Os bad boys da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://static.readdy.ai/image/1994e90a97157f2e2b62c14dfd6ce361/c345a296ccb216a6ca406ad6b6c7b0fc.png",
    expressions: ["Presa"],
    variants: [6, 7, 8, 9, 10, 11]
  },
  {
    id: 7,
    name: "Sammy Suckerpunch",
    species: "Lobo",
    wave: "Chaveiro",
    rarity: "Raro",
    year: 2017,
    size: "Chaveiro",
    description: "É um cachorro! Eles são fofos, mas são bravos! Os bichinhos de pelúcia Feisty Pets vão te atacar se você apertá-los. Os bad boys da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://static.readdy.ai/image/1994e90a97157f2e2b62c14dfd6ce361/5e249c37b25bd062ab4f65b03bd48238.png",
    expressions: ["Presa"],
    variants: [6, 7, 8, 9, 10, 11]
  },
  {
    id: 8,
    name: "Sammy Suckerpunch",
    species: "Lobo",
    wave: "Jumbo",
    rarity: "Comum",
    year: 2017,
    size: "Jumbo",
    description: "É um cachorro! Eles são fofos, mas são bravos! Os bichinhos de pelúcia Feisty Pets vão te atacar se você apertá-los. Os bad boys da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://static.readdy.ai/image/1994e90a97157f2e2b62c14dfd6ce361/5bdc5fd88234643abc372b9b14eb1eb6.png",
    expressions: ["Presa"],
    variants: [6, 7, 8, 9, 10, 11]
  },
  {
    id: 9,
    name: "Sammy Suckerpunch",
    species: "Lobo",
    wave: "Normal",
    rarity: "Raro",
    year: 2017,
    size: "Normal",
    description: "É um cachorro! Eles são fofos, mas são bravos! Os bichinhos de pelúcia Feisty Pets vão te atacar se você apertá-los. Os bad boys da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://static.readdy.ai/image/1994e90a97157f2e2b62c14dfd6ce361/68646c023be0d1d7b5b2392006163396.png",
    expressions: ["Sorriso"],
    variants: [6, 7, 8, 9, 10, 11]
  },
  {
    id: 10,
    name: "Sammy Suckerpunch",
    species: "Lobo",
    wave: "Normal",
    rarity: "Comum",
    year: 2017,
    size: "Normal",
    description: "É um cachorro! Eles são fofos, mas são bravos! Os bichinhos de pelúcia Feisty Pets vão te atacar se você apertá-los. Os bad boys da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://static.readdy.ai/image/1994e90a97157f2e2b62c14dfd6ce361/5558826518b5cce66ff1486cbeb1159a.png",
    expressions: ["Doofus"],
    variants: [6, 7, 8, 9, 10, 11]
  },
  {
    id: 11,
    name: "Sammy Suckerpunch",
    species: "Lobo",
    wave: "Normal",
    rarity: "Épico",
    year: 2017,
    size: "Normal",
    description: "É um cachorro! Eles são fofos, mas são bravos! Os bichinhos de pelúcia Feisty Pets vão te atacar se você apertá-los. Os bad boys da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://static.readdy.ai/image/1994e90a97157f2e2b62c14dfd6ce361/3e6d45053f3e147a3e9cdb4368edbb41.png",
    expressions: ["Língua"],
    variants: [6, 7, 8, 9, 10, 11]
  },

  // LIGHTNINGBOLT LENNY - PREGUIÇA
  {
    id: 12,
    name: "Lightningbolt Lenny",
    species: "Preguiça",
    wave: "Normal",
    rarity: "Raro",
    year: 2017,
    size: "Normal",
    description: "É uma preguiça! Elas são fofas, mas são bravas! Os bichinhos de pelúcia Feisty Pets se voltam contra você se você os apertar. Os bad boys da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://i.imgur.com/l3L8R3q.png",
    expressions: ["Presa"],
    variants: [12, 13]
  },
  {
    id: 13,
    name: "Lightningbolt Lenny",
    species: "Preguiça",
    wave: "Normal",
    rarity: "Épico",
    year: 2017,
    size: "Normal",
    description: "É uma preguiça! Elas são fofas, mas são bravas! Os bichinhos de pelúcia Feisty Pets se voltam contra você se você os apertar. Os bad boys da pelúcia. Você não vai gostar de mim quando eu estiver bravo...",
    image: "https://i.imgur.com/4kbhwfM.png",
    expressions: ["Doofus"],
    variants: [12, 13]
  },

  // LIGHTNINGBOLT LUCY - PREGUIÇA ROXA
  {
    id: 14,
    name: "Lightningbolt Lucy",
    species: "Preguiça Roxa",
    wave: "Normal",
    rarity: "Comum",
    year: 2017,
    size: "Normal",
    description: "É uma preguiça roxa adorável da linha Feisty Pets que se transforma em uma criatura agressiva quando apertada. Ela é rápida e ágil, com um passado misterioso envolvendo uma fuga de contrabando de animais exóticos, e seu apelido \"Lightning Bolt\" (Raio) vem daí. Seus gostos incluem correspondência, acampamento no sofá e besouros, enquanto desgosta de tudo que for rápido, hip hop e bife.",
    image: "https://i.imgur.com/QVS71xl.png",
    expressions: ["Presa"],
    variants: [14]
  },

  // DERBY - URSO NEGRO
  {
    id: 15,
    name: "Derby",
    species: "Urso Negro",
    wave: "Normal",
    rarity: "Lendário",
    year: 2017,
    size: "Normal",
    description: "O urso negro.",
    image: "https://i.imgur.com/hpmvje5.png",
    expressions: ["Língua"],
    variants: [15]
  },

  // SCARED STEVE - HALLOWEEN
  {
    id: 16,
    name: "Scared Steve",
    species: "Halloween",
    wave: "Normal",
    rarity: "Comum",
    year: 2017,
    size: "Normal",
    description: "Steve é ​​um medroso, não um monstro. Ele se assusta facilmente, então usa sua fantasia de Halloween o ano todo para se sentir mais corajoso. Mas quando Steve sai por aí com sua fantasia de monstro em uma terça-feira qualquer, todo mundo acaba ficando mais apavorado do que ele.",
    image: "https://i.imgur.com/X9gfi0a.png",
    expressions: ["Assustado"],
    variants: [16]
  },

  // SUPER DOOFUS
  {
    id: 17,
    name: "Super Doofus",
    species: "Super Doofus",
    wave: "Normal",
    rarity: "Comum",
    year: 2017,
    size: "Normal",
    description: "Era um urso de negócios de sucesso até o dia em que caiu num banheiro químico em um canteiro de obras. A picada de uma pulga radioativa rara o transformou no herói hilariamente atrapalhado, SUPER DOOFUS!",
    image: "https://i.imgur.com/1K3ntpu.png",
    expressions: ["Doofus"],
    variants: [17]
  }
];
